import { LDObject } from 'emt-library'

export enum SOFieldTypes {
  BOOLEAN = 'boolean',
  NUMBER = 'number',
  STRING = 'string',
  ARRAY = 'array',
  DATE = 'date', // When field type is date and comparison is Number Comparison use cycle and duration
}

export enum SOComparisons {
  // Common Comparison
  STRICT_EQUAL = '==',
  NOT_EQUAL = '!=',
  NULL_OR_UNDEFINED = 'NULL',

  // Array Comparison
  SOME = 'SOME',
  EVERY = 'EVERY',
  EXCLUDE = 'EXCLUDE',
  EMPTY = 'EMPTY',
  COUNT_LESS_THAN = '<COUNT',
  COUNT_MORE_THAN = 'COUNT>',

  // Number Comparison ( can be used with duration comparison when date fieldType )
  LESS_THAN = '<',
  LESS_THAN_OR_EQUAL = '<=',
  MORE_THAN = '>',
  MORE_THAN_OR_EQUAL = '>=',

  // String Comparison
  REGEX = 'REGEX',
}

export enum SOStoreTypes {
  User = 'user',
  Animal = 'animal',
}

export type SOScreen = LDObject<'screen'> & {
  id: string
  name: string
  slug: string
}

export type SOSchemaRule<TypeT> = LDObject<'SchemaRule'> & {
  id: string
  field: string
  fieldType: SOFieldTypes
  value: string
  type: TypeT
  comparison: SOComparisons
}

export type ShadowOptin = LDObject<'SchemaRule'> & {
  id: string
  name: string
  title: string
  description: string
  replaceDescriptionByUrl: boolean
  screen: SOScreen[]
  screenRule: SOSchemaRule<string>[]
  storeRule: SOSchemaRule<SOStoreTypes>[]
  urlHref?: string
  urlText?: string
}

/**
 * Screens slugs used on mobile app
 */
export enum SODesktopScreenSlugs {
  Register_DisponibilityChoices = 'register-disponibilityChoices',
  Register_About = 'register-about',
  Register_Address = 'register-address',
  Register_Photos = 'register-photos',
  Register_Description = 'register-description',
  Register_DogProfile = 'register-dogProfile',
  Register_DogAffinityChoices = 'register-dogAffinityChoices',
  Register_Insurance = 'register-insurance',
  Register_Profile = 'profile',
  Register_Settings = 'settings',
  Disable_Renewal = 'disable-renewal',
  Delete_Account = 'delete-account',
}
